import React, { memo } from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div data-id="element-3">
          <div className="text-center mb-10" data-id="element-4">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-5">
              🎁 6 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-[#A855F7] font-bold text-lg" data-id="element-6">
              SIEMPRE INCLUIDOS
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
            {/* Bono 1 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-8">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-9">01</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
                🎁 BONO 1
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
                KIT PRIMERA CLASE PERFECTA
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
                Convertí cualquier alumno nuevo en alumno fijo desde la primera
                clase. Guion listo + ficha de ingreso + mini diagnóstico en 10
                minutos.
              </p>
              <div className="flex items-center gap-2" data-id="element-13">
                <span className="text-gray-400 line-through text-sm" data-id="element-14">
                  $15.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-16">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-17">02</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
                🎁 BONO 2
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
                BANCO DE CUES "PROFE QUE ENSEÑA"
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
                300 frases listas para sonar más profesional en cada clase. 80
                correcciones "Si pasa X — Decí Y" para cada error frecuente.
              </p>
              <div className="flex items-center gap-2" data-id="element-21">
                <span className="text-gray-400 line-through text-sm" data-id="element-22">
                  $12.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-24">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-25">03</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
                🎁 BONO 3
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
                SISTEMA "PROGRESO VISIBLE"
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
                Hacé que tus alumnos vean su avance en 4 semanas. Tablero + test
                inicial/final + script de renovación basado en resultados
                reales.
              </p>
              <div className="flex items-center gap-2" data-id="element-29">
                <span className="text-gray-400 line-through text-sm" data-id="element-30">
                  $10.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-32">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-33">04</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
                🎁 BONO 4
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
                CLASES GRUPALES SIN CAOS
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
                Manejá grupos de 6 a 15 alumnos con control total. 5 modelos de
                clase grupal + mapas de tiempo + hojas de estación imprimibles.
              </p>
              <div className="flex items-center gap-2" data-id="element-37">
                <span className="text-gray-400 line-through text-sm" data-id="element-38">
                  $12.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 5 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-40">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-41">05</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
                🎁 BONO 5
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
                KIT ANTI-CANCELACIONES
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
                Reducí ausencias con mensajes listos y un sistema semanal que
                funciona solo. 20 mensajes copy/paste — Sistema 3 Toques —
                Política amable pero firme.
              </p>
              <div className="flex items-center gap-2" data-id="element-45">
                <span className="text-gray-400 line-through text-sm" data-id="element-46">
                  $10.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 6 */}
            <div className="bg-[#1a0d2e] border border-[#A855F7] rounded-2xl p-6 flex flex-col" data-id="element-48">
              <div className="text-4xl font-black text-[#A855F7] mb-1" data-id="element-49">06</div>
              <div className="text-[#A855F7] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
                🎁 BONO 6
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
                EXPERIENCIA PREMIUM
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
                Convertí una clase normal en una experiencia que el alumno
                recuerda toda la semana. 5 rituales de inicio + guía musical por
                BPM + 5 rituales de cierre memorable.
              </p>
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-gray-400 line-through text-sm" data-id="element-54">
                  $10.000
                </span>
                <span className="bg-[#A855F7] text-white font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="border border-[#A855F7]/40 rounded-2xl p-6 text-center bg-[#0d0818]" data-id="element-56">
            <p className="text-[#A855F7] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
              Valor total bonos
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 mb-2" data-id="element-58">
              <span className="text-gray-400 line-through text-lg" data-id="element-59">
                $69.000
              </span>
              <span className="text-[#A855F7] text-xl sm:text-2xl font-black tracking-wide" data-id="element-60">
                → GRATIS con tu MegaPack
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}